import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=69f8e628&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=ts"
export * from "./Contacts.vue?vue&type=script&lang=ts"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=69f8e628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f8e628",
  null
  
)

export default component.exports